export default __webpack_public_path__ + "static/media/progressiveBudget.6be1d0c7.png";